interface HeroSectionProps {
  onLoginClick: () => void;
  onRegisterClick: () => void;
}

export default function HeroSection({ onLoginClick, onRegisterClick }: HeroSectionProps) {
  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20minimalist%20artistic%20abstract%20composition%20with%20warm%20beige%20cream%20and%20dark%20charcoal%20tones%20featuring%20flowing%20organic%20shapes%20and%20subtle%20geometric%20patterns%20soft%20diffused%20lighting%20elegant%20and%20sophisticated%20atmosphere%20suitable%20for%20a%20professional%20corporate%20website%20hero%20background%20no%20text%20no%20people&width=1920&height=1080&seq=carland-hero-001&orientation=landscape"
          alt="کارلند - امنیت شغلی"
          className="w-full h-full object-cover object-top"
          loading="eager"
          decoding="async"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-12 lg:px-20 py-32 md:py-40">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Text Content */}
          <div className="flex-1 text-right">
            {/* Badge */}
            <div className="inline-block mb-6 spring-in-up" style={{ animationDelay: '0.1s', opacity: 0 }}>
              <span className="px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-xs font-medium">
                از سال ۱۳۹۳ در خدمت شما هستیم
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-7xl font-black text-white leading-tight mb-6 spring-in-right" style={{ animationDelay: '0.3s', opacity: 0 }}>
              امنیت شغلی واقعی
              <br />
              <span className="text-carland-accent">استخدام دائمی</span> با کارلند
            </h1>

            <p className="text-white/70 text-base md:text-lg leading-relaxed max-w-xl mb-8 spring-in-right" style={{ animationDelay: '0.5s', opacity: 0 }}>
              بیش از ۱۳ سال سابقه فعالیت حرفه‌ای در حوزه کاریابی و اخذ مجوزهای رسمی از مراجع ذی‌ربط. 
              ما پل ارتباطی مطمئن میان ۴۷,۰۰۰+ استعداد و صنعت هستیم.
            </p>

            {/* Login & Register Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 spring-in-up" style={{ animationDelay: '0.7s', opacity: 0 }}>
              <button
                onClick={onLoginClick}
                className="px-10 py-4 rounded-full bg-white text-carland-dark font-bold text-base hover:bg-carland-cream transition-all duration-300 cursor-pointer whitespace-nowrap inline-flex items-center gap-3 shadow-lg hover:shadow-xl hover:-translate-y-0.5"
              >
                <i className="ri-login-box-line text-xl"></i>
                <span>ورود به حساب</span>
              </button>
              <button
                onClick={onRegisterClick}
                className="px-10 py-4 rounded-full bg-carland-dark text-white font-bold text-base border border-white/20 hover:bg-carland-darker hover:border-white/40 transition-all duration-300 cursor-pointer whitespace-nowrap inline-flex items-center gap-3 hover:-translate-y-0.5"
              >
                <i className="ri-user-add-line text-xl"></i>
                <span>ثبت‌نام در کارلند</span>
              </button>
            </div>
          </div>

          {/* Visual Element */}
          <div className="flex-1 hidden lg:flex items-center justify-center">
            <div className="relative spring-in-scale" style={{ animationDelay: '0.5s', opacity: 0 }}>
              {/* Decorative frame */}
              <div className="w-80 h-96 rounded-3xl bg-carland-cream/10 backdrop-blur-sm border border-white/10 p-3">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20corporate%20office%20interior%20with%20warm%20lighting%20modern%20minimalist%20design%20featuring%20a%20sleek%20desk%20with%20documents%20and%20a%20subtle%20green%20plant%20elegant%20sophisticated%20atmosphere%20warm%20beige%20and%20cream%20tones&width=600&height=720&seq=carland-hero-office-002&orientation=portrait"
                  alt="دفتر کارلند"
                  className="w-full h-full object-cover rounded-2xl"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              {/* Floating badge */}
              <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl px-5 py-4 shadow-lg animate-float-slow">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-carland-cream flex items-center justify-center">
                    <i className="ri-shield-check-line text-2xl text-carland-accent"></i>
                  </div>
                  <div className="text-right">
                    <p className="text-carland-dark font-bold text-lg">۴۷,۰۰۰+</p>
                    <p className="text-carland-muted text-xs">کاربر ثبت‌نامی</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs">اسکرول کنید</span>
        <i className="ri-arrow-down-line text-white/50"></i>
      </div>
    </section>
  );
}